import {
  CustomGetQuickbooksSyncJobsQuery,
  CustomGetQuickbooksSyncJobsQueryVariables,
  useCustomGetQuickbooksSyncJobsQuery,
} from "generated/graphql";
import { useCallback, useMemo } from "react";

export default function useGetQuickbooksSyncJobs({
  variables,
}: {
  variables: CustomGetQuickbooksSyncJobsQueryVariables;
}) {
  const { data: graphqlData, error, loading } = useCustomGetQuickbooksSyncJobsQuery({ variables });

  const getData = useCallback(({ data }: { data?: CustomGetQuickbooksSyncJobsQuery }) => {
    return data?.getJobs?.data ?? null;
  }, []);

  const data = useMemo(() => getData({ data: graphqlData }), [getData, graphqlData]);

  return { data, error, loading } as const;
}
